import { render, staticRenderFns } from "./UploadProductImages.vue?vue&type=template&id=55835424&scoped=true"
import script from "./UploadProductImages.vue?vue&type=script&lang=js"
export * from "./UploadProductImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55835424",
  null
  
)

export default component.exports